import { IconButton, Stack, styled, Typography } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import { useInjection } from './hook';
import React from 'react';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { HeaderClient } from '../../Clients/conponents/HeaderClient';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { Controller } from 'react-hook-form';
import { AddIcon } from 'assets';
export const CreateLocation = () => {
  const {
    backToClient,
    handleSubmit,
    onCreateLocation,
    errors,
    fieldNames,
    append,
    remove,
    control,
    paths,
    title
  } = useInjection();
  return (
    <WrapperCreatePage>
      <HeaderClient
        paths={paths}
        onClickButton={backToClient}
        textButton={'Cancel'}
        title={title.textButton}
      />
      <Stack alignItems={'center'} justifyContent={'space-between'} flexDirection={'row'}>
        <Stack alignItems={'flex-start'} gap={2} width={'100%'}>
          <Stack gap={'10px'} width={'100%'} maxWidth={'532px'}>
            <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
              <Typography fontSize={'16px'} fontWeight={700} color={'#226AAA'}>
                Add New
              </Typography>
              <IconButton
                onClick={() => append({ value: '' })}
                sx={{ width: '40px', height: '40px' }}>
                <AddIcon color={'#000'} />
              </IconButton>
            </Stack>
            {fieldNames.map((field, index) => {
              return (
                <Stack key={field.id} direction="row" spacing={2} alignItems="center" mb={2}>
                  <Controller
                    name={`names.${index}.value`}
                    control={control}
                    render={({ field }) => {
                      return (
                        <InputText
                          inputError={errors.names?.[index]?.value?.message}
                          title={'New location'}
                          placeholder={'Name'}
                          inputProps={{
                            ...field
                          }}
                        />
                      );
                    }}
                  />
                  <IconButton onClick={() => remove(index)}>
                    <RemoveCircleOutlineIcon color={'error'} />
                  </IconButton>
                </Stack>
              );
            })}
          </Stack>
          <Stack>
            <ButtonCustom
              onClick={handleSubmit(onCreateLocation)}
              label={'Add New'}
              style={{ width: '370px' }}
            />
          </Stack>
        </Stack>
      </Stack>
    </WrapperCreatePage>
  );
};
const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 50px 40px',
  width: '100%'
}));
